<template>
    <VPerfectSignature 
      v-if="loadingCanvas"
      :stroke-options="strokeOptions" 
      ref="signaturePad" 
      class="my-4 mx-auto myCanvas  "
      style="border: 1px solid grey;"
      penColor="#000"
      @onBegin="bandSignature = true"
    />
    <v-progress-circular indeterminate class="ma-auto" v-else></v-progress-circular>
</template>

<script>
import VPerfectSignature from 'v-perfect-signature';
import { VProgressCircular } from 'vuetify/lib';

export default {
  components: {
    VPerfectSignature, VProgressCircular
  },
  props: {
    type: {
      type: String,
      default: 'Signature'
    },
    idCanvas: { type: String, default: "0" },
    sizeCanvas: { type: Boolean, default: false }
  },
  data() {
    return {
      x: 0,
      y: 0,
      isDrawing: false,
      canvas: null,
      bandSignature: false,
      widthCanvas: 600,
      windowWidth: 0,
      strokeOptions: {
        size: 5,
        thinning: 0.25,
        smoothing: 0.25,
        streamline: 0.25,
      },
      loadingCanvas: false
    }
  },
  methods: {
    drawLine(x1, y1, x2, y2) {
      let ctx = this.canvas;
      ctx.beginPath();
      ctx.strokeStyle = 'black';
      ctx.lineWidth = 3;
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
      ctx.closePath();
    },
    beginDrawing(e, type = false) {
      if(!type) {
        this.x = e.offsetX;
        this.y = e.offsetY;
      } else {
        const position = document.getElementById(`myCanvas-${this.idCanvas}`).getBoundingClientRect();
        this.x = e.changedTouches[0].pageX - position.x;
        this.y = e.changedTouches[0].pageY - position.y;
      }
      
      this.isDrawing = true;
    },
    keepDrawing(e) {
      if (this.isDrawing === true) {
        this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
        this.x = e.offsetX;
        this.y = e.offsetY;
        this.bandSignature = true;
      }
    },
    stopDrawing(e) {
      if (this.isDrawing === true) {
        this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
        this.x = 0;
        this.y = 0;
        this.isDrawing = false;
      }
    },
    cleanCanvas() {
        /*const c = document.getElementById(`myCanvas-${this.idCanvas}`);
        this.canvas.fillStyle = "#fff";
        this.canvas.fillRect(0, 0, c.width, c.height);*/
        this.bandSignature = false;
        this.$refs.signaturePad.clear();
    },
    getImage() {
        this.$emit("getImage", this.$refs.signaturePad.toDataURL("image/png"));
    },
    resizeCanvas() {
      /*this.windowWidth = window.innerWidth;
      if(this.windowWidth < 685) {
        let width = document.getElementById(`myCanvas-${this.idCanvas}`).clientWidth;
        if(width == 0) {
          width = this.windowWidth - 98;
        }
        this.widthCanvas = width;
      } else {
        this.widthCanvas = 600;
      }*/
      if(this.sizeCanvas) {
        const sign = this.$refs.signaturePad;
        if(sign) sign.resizeCanvas(true);
      }
    },
    initCanvas() {
      /*const c = document.getElementById(`myCanvas-${this.idCanvas}`);
      this.canvas = c.getContext('2d');*/
    }
  },
  mounted() {
    /*this.initCanvas();*/
    const parent = this;
    setTimeout(() => { parent.loadingCanvas = true }, 1000);
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        parent.resizeCanvas();
      });
    });
  }, 
  watch: {
    bandSignature(val) {
      this.$emit("changeBandSignature", { value: !val, type: this.type});
    },
    sizeCanvas(val) {
      if(val) {
        this.loadingCanvas = false;
        this.$emit("changeBandSignature", { value: val, type: this.type});
        const parent = this;
        setTimeout(() => { 
          parent.loadingCanvas = true;
          this.$emit("changeBandSignature", { value: !val, type: this.type});
        }, 1000);
      }
    }
  }
};
</script>

<style>
.myCanvas {
  border: 1px solid grey;
  min-width: 100%;
  max-width: 100%;
}
/*@media (max-width: 685px) {
  .myCanvas {
    min-width: 100%;
    max-width: 100%;
  }
}*/
</style>